export { SliderCard } from './SliderCard';
